/* eslint-disable max-len */
import React from 'react';

const Quote = () => (
  <div className="container">
    <h3>
      Mathematics is a language. — Josiah Willard Gibbs, American scientist
    </h3>
    <h3>
      As far as the laws of mathematics refer to reality, they are not certain,
      and as far as they are certain, they do not refer to reality. — Albert
      Einstein
    </h3>
    <h3>
      Mathematics are the result of mysterious powers which no one understands,
      and which the unconscious recognition of beauty must play an important
      part. Out of an infinity of designs a mathematician chooses one pattern
      for beauty’s sake and pulls it down to earth. — Marston Morse, American
      mathematician
    </h3>
  </div>
);

export default Quote;
